import { render, staticRenderFns } from "./CadastreBuildingFixSizeList.vue?vue&type=template&id=331dfb74&scoped=true&"
import script from "./CadastreBuildingFixSizeList.vue?vue&type=script&lang=js&"
export * from "./CadastreBuildingFixSizeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331dfb74",
  null
  
)

export default component.exports